<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12">
            <v-expansion-panels flat popout hover>
              <v-expansion-panel
              >
                <v-expansion-panel-header class="bg-light">
                  <span><v-icon left>mdi-magnify</v-icon>Detaylı Arama</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeStart)"
                                label="Tarih Aralık Başlangıç"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeStart = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeStart"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeEnd)"
                                label="Tarih Aralık Bitiş"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeEnd = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeEnd"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'supplier'"
                            @itemChange="(e) => (selectedSupplier = e)"
                            :label="'Tedarikçi'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'stock'"
                            @itemChange="(e) => (selectedStock = e)"
                            :label="'Stok'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="groupCodeValue"
                            label="Grup Kodu"
                            :items="groupCodeList"
                            item-text="name"
                            item-value="code"
                            filled
                            solo
                            dense
                            clearable
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="salesPersonCode"
                            label="Plasiyer"
                            filled
                            solo
                            dense
                            clearable
                            :items="salesPersonList"
                            :item-text="item => item.name"
                            :item-value="item => item.code"
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-12 text-end">
                        <v-btn
                            color="primary darken-1"
                            small
                            @click="_fetchPurchaseOrders"
                        >
                          <v-icon left>mdi-magnify</v-icon>
                          Filtrele
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div>
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10</v-btn>
                <v-btn @click="perPage = 20"> 20</v-btn>
                <v-btn @click="perPage = 30"> 30</v-btn>
                <v-btn @click="perPage = 50"> 50</v-btn>
                <v-btn @click="perPage = 100"> 100</v-btn>
              </v-btn-toggle>
            </div>
          </div>
        </div>
        <div class="row">
          <p class="text-start">Toplam <b>{{ purchaseOrdersMetaData.totalCount ?? 0 }}</b> Kayıt Bulundu</p>
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      plain
                      :loading="allDataForExcelLoading"
                      :disabled="allDataForExcel.length > 1"
                      v-bind="attrs"
                      v-on="on"
                      @click="getAllDataForExcel"
                  >
                    <v-icon color="indigo" small class="me-2">mdi-information</v-icon>
                    <span>Verileri İndir</span>
                  </v-btn>
                </template>
                <span>Tüm Verileri Excel Olarak Aktarmak İçin Önce İndiriniz</span>
              </v-tooltip>
              <ExcelExport
                  :button-enabled="!excelButton"
                  :button-title="'Tüm Sayfalar'"
                  :dataProp="allDataForExcel"
                  :columnProp="purchaseOrdersHeaders"
                  :fileNameProp="'Bekleyen Siparişler ' + formattedDate(new Date(), 'DD-MM-YYYY HH:mm:ss')"
              />
              <ExcelExport
                  :button-title="'Mevcut Sayfa'"
                  :dataProp="purchaseOrders"
                  :columnProp="purchaseOrdersHeaders"
                  :fileNameProp="'Bekleyen Siparişler ' + formattedDate(new Date(), 'DD-MM-YYYY HH:mm:ss')"
              />
              <PrintPage :divId="'printPendingOrders'"></PrintPage>
            </div>
            <v-btn v-if="this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1'"
                   small color="info darken-1"
                   @click="purchaseOrderDialog = true">Satın Alma Siparişi Oluştur</v-btn>
          </div>
          <ResultTableView :perPage="perPage" :currentPage="currentPage"></ResultTableView>
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="purchaseOrdersMetaData.totalPages"
                :total-visible="8"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
    <PurchaseOrderDialog :showDialog="purchaseOrderDialog" @dialogChange="(e) => (purchaseOrderDialog = e)" ></PurchaseOrderDialog>

  </div>

</template>

<script>
import ResultTableView from "@/components/orders/PurchaseOrders/results/ResultsTableView.vue";
import {formattedDate} from "@/momentHelper";
import {mapState, mapActions} from "vuex";
import SearchSelect from "@/components/searchSelect.vue";
import ExcelExport from "@/components/shared/ExcelExport.vue";
import PrintPage from "@/components/shared/PrintPage.vue";
import PurchaseOrderDialog from "@/components/orders/PurchaseOrders/dialogs/NewPurchaseOrderDialog.vue";
import {getPurchaseOrderList} from "@/services/modules/orders/orderService";

export default {
  components: {
    PurchaseOrderDialog,
    SearchSelect,
    ResultTableView,
    ExcelExport,
    PrintPage
  },
  props: {
    listType: {
      type: String,
      default: "SiparisList"
    }
  },
  mounted() {
    this.fetchSalesPersonList({
      params: {},
      body: {}
    });
    this._fetchPurchaseOrders();
  },
  computed: {
    ...mapState("order", ["purchaseOrders", "purchaseOrdersHeaders", "purchaseOrdersLoading","purchaseOrdersMetaData"]),
    ...mapState("auth", ["user"]),
    ...mapState("current", ["salesPersonList"]),
    excelButton: function () {
      return this.allDataForExcel.length > 0
    }
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      dateRangeStart: null,
      dateRangeEnd: null,
      selectedCurrent: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      stockSearchResult: [],
      searchStockTimeout: null,
      selectedStock: null,
      stockSearchText: "",
      searchStockLoading: false,
      searchText: null,
      statusValue: null,
      salesPersonCode: null,
      groupCodeList:[],
      groupCodeList1:[],
      groupCodeList2:[],
      groupCodeList3:[],
      groupCodeList4:[],
      groupCodeList5:[],
      groupCodeValue:null,
      groupCodeValue1:null,
      groupCodeValue2:null,
      groupCodeValue3:null,
      groupCodeValue4:null,
      groupCodeValue5:null,
      cityValue: null,
      townValue: null,
      selectedSupplier: null,
      purchaseOrderDialog: false,
      allDataForExcel: [],
      allDataForExcelLoading: false,
    };
  },
  methods: {
    getPurchaseOrderList,
    formattedDate,
    ...mapActions("order", ["fetchPurchaseOrders"]),
    ...mapActions("current", ["fetchSalesPersonList", "fetchCurrentList"]),
    async _fetchPurchaseOrders() {
      await this.fetchPurchaseOrders({
        params: {
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          userId: this.user.UserId,
          ...(!(this.dateRangeStart === "" || this.dateRangeStart == null)) && {startDate: this.dateRangeStart},
          ...(!(this.dateRangeEnd === "" || this.dateRangeEnd == null)) && {finishDate: this.dateRangeEnd},
          ...(!(this.dateRangeEnd === "" || this.dateRangeEnd == null)) && {finishDate: this.dateRangeEnd},
          ...(!(this.salesPersonCode === "" || this.salesPersonCode == null)) && {salesPersonCode: this.salesPersonCode},
          ...(!(this.selectedSupplier === "" || this.selectedSupplier == null)) && {supplierCode: this.selectedSupplier},
          //Branch code
        },
        body: {}
      })
    },
    async getAllDataForExcel() {
      this.allDataForExcelLoading = true;
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.purchaseOrdersMetaData.totalCount,
        ...(!(this.dateRangeStart === "" || this.dateRangeStart == null)) && {startDate: this.dateRangeStart},
        ...(!(this.dateRangeEnd === "" || this.dateRangeEnd == null)) && {finishDate: this.dateRangeEnd},
        ...(!(this.dateRangeEnd === "" || this.dateRangeEnd == null)) && {finishDate: this.dateRangeEnd},
        ...(!(this.salesPersonCode === "" || this.salesPersonCode == null)) && {salesPersonCode: this.salesPersonCode},
        ...(!(this.selectedSupplier === "" || this.selectedSupplier == null)) && {supplierCode: this.selectedSupplier},
      }
      let body = {}
      let result = await this.getPurchaseOrderList(params,body)
      this.allDataForExcel = result.data.data;
      this.allDataForExcelLoading = false;
    },
  },
  watch: {
    stockSearchText: function (newVal) {
      if (newVal && (newVal.length > 2)) {
        this.stockSearchResult = [];
        if (this.searchStockTimeout)
          clearTimeout(this.searchStockTimeout);
        this.searchStockLoading = true
        this.searchStockTimeout = setTimeout(() => {

          this._fetchStockList();

        }, 2000);
      }
    },
    currentSearchText: function (newVal) {
      if (newVal && (newVal.length > 2)) {
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList();
        }, 1500);
      } else {
        this.searchCurrentLoading = false;
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
      }
    },
    perPage: function (newVal) {
      newVal;
      this.perPage = newVal;
      this._fetchPendingOrders();
    },

    currentPage: function (newVal) {
      newVal;
      this.currentPage=newVal
      this._fetchPendingOrders();
    }
  }
};
</script>